import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdIdentifierService {
  static async detail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(wizStandardInstance.get(`​/api/std/StdIdentifier/${payload.id}`))
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdIdentifier?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdIdentifier', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdIdentifier', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdIdentifier', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdIdentifier/import', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdIdentifier/export', payload))
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdIdentifier/download', payload)
    )
    return Callback(err, res)
  }
}
